import React from "react";
import Modal from "react-modal";
import ProductAddedPopInContent from "./ProductAddedPopInContent";

const ProductAddedPopIn = (props) => {
  return (
    <Modal
      isOpen={Boolean(props.product)}
      onRequestClose={props.hidePopin}
      overlayClassName="modal__overlay product-added__overlay"
      contentLabel="Product Added Window"
      className="modal__content product-added"
    >
      {props.product && (
        <ProductAddedPopInContent
          product={props.product}
          hidePopin={props.hidePopin}
        />
      )}
    </Modal>
  );
};

export default ProductAddedPopIn;
